import { render, staticRenderFns } from "./CPGameAdmin.vue?vue&type=template&id=30af8a1e"
import script from "./CPGameAdmin.vue?vue&type=script&lang=js"
export * from "./CPGameAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports